"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const DeleteAccountFourScreen = (props) => {
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            justifyContent: 'space-between',
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                }, title: 'アカウント削除', styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#007AFF',
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.DELETE_ACCOUNT_SCREEN);
                } }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#292A33',
                            fontWeight: '300',
                            paddingLeft: (0, scale_1.scale)(8),
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u884C\u3046\u524D\u306B")),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u524A\u9664\u3057\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B\u306B\u306F\u3001\u539F\u5247\u3001\u8EAB\u5206\u8A3C\u660E\u66F8\u7B49\u306B\u3088\u308B\u672C\u4EBA\u78BA\u8A8D\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u96FB\u8A71\u756A\u53F7\u53CA\u3073\u751F\u5E74\u6708\u65E5\u306E\u767B\u9332\u3092\u884C\u3046\u3053\u3068\u3067\u3001\u7C21\u7565\u5316\u3067\u304D\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30DE\u30A4\u30DA\u30FC\u30B8\u304B\u3089\u7167\u5408\u7528\u60C5\u5831\u306E\u5165\u529B\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002"),
                react_1.default.createElement(components_1.BorderButton, { title: '\u7167\u5408\u7528\u60C5\u5831\u3092\u5165\u529B', textStyle: {
                        fontSize: (0, scale_1.moderateScale)(16),
                        lineHeight: (0, scale_1.moderateScale)(24),
                        color: '#1960B0'
                    }, style: {
                        width: '100%',
                        height: (0, scale_1.scale)(48),
                        marginTop: (0, scale_1.scale)(32),
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.DISPLAY_INFORMATION_SCREEN);
                    } }),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(20) }, fontWeight: "600", title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664", onPress: () => {
                        props.navigation.navigate(Routes_1.default.REASON_DELETE_SCREEN);
                    } })))));
};
exports.default = DeleteAccountFourScreen;
